<template>
  <div class="country-field">
    <div class="country-field__country-select">
      <m4-select
        ref="country_field"
        :options="countries"
        v-bind="countryAttrs"
        :value="country"
        @change="changeCountry"
      >
        <option value="">{{ emptyString }}</option>
        <optgroup label="Most used">
          <option v-for="(country, index) in mostUsedCountries" :key="index" :value="country.value">
            {{ country.label }}
          </option>
        </optgroup>
        <optgroup label="All countries">
          <option v-for="(country, index) in countries" :key="index" :value="country.value">
            {{ country.label }}
          </option>
        </optgroup>
      </m4-select>
      <m4-hint v-if="countryError" class="form-field__error-hint" variant="error">{{ countryError }}</m4-hint>
    </div>
    <div v-if="statesAllowed && this.stateOptions().length" class="country-field__state-select">
      <m4-select
        ref="state_field"
        :options="this.stateOptions()"
        :name="stateName ? stateName : $attrs.name + '__state'"
        :placeholder="statePlaceholder"
        :label-above="stateLabelAbove"
        :value="state"
        @change="changeState"
        :error="$attrs.error ? !!$attrs.error : !!stateError"
        v-bind="stateAttrs"
      ></m4-select>
      <m4-hint v-if="stateError" class="form-field__error-hint" variant="error">{{ stateError }}</m4-hint>
    </div>
  </div>
</template>

<script>
export default {
  name: "M4CountryField",
  data() {
    return {
      states: [],
      country: this.$attrs.value,
      state: this.stateValue
    };
  },
  props: {
    countries: {
      type: Array
    },
    stateName: {
      type: String
    },
    stateValue: {
      type: String
    },
    statePlaceholder: {
      type: String
    },
    stateLabelAbove: {
      type: String
    },
    stateError: {
      type: String
    },
    countryError: {
      type: String
    },
    emptyString: {
      type: String,
      default() {
        return "";
      }
    },
    statesAllowed: {
      type: Boolean,
      default() {
        return true;
      }
    }
  },
  emits: ["changeCountry", "changeState"],
  computed: {
    countryAttrs() {
      return Object.assign({}, this.$attrs, {
        error: this.countryError ? !!this.countryError : !!this.$attrs.error
      });
    },
    stateAttrs() {
      return Object.assign({}, this.countryAttrs.disabled ? { disabled: true } : {});
    },
    mostUsedCountries() {
      return this.countries.filter((country) => country.mostused);
    }
  },
  methods: {
    setCountry(country) {
      this.country = country;
      this.$refs.country_field.setSelected(this.country);
    },
    setState(state) {
      this.state = state;
      this.$nextTick(function () {
        this.$refs.state_field.setSelected(state);
      });
    },
    stateOptions() {
      let states = [];
      let currCountry = this.countries.find((country) => country.value === this.country);
      if (currCountry !== undefined && currCountry.states !== undefined && currCountry.states.length) {
        states = currCountry.states;
      }
      return states;
    },
    changeCountry(e) {
      this.country = e.target.value;
      this.$emit("changeCountry", this.country);
    },
    changeState(e) {
      this.state = e.target.value;
      this.$emit("changeState", this.state);
    }
  },
  watch: {
    country() {
      this.state = null;
    }
  }
};
</script>
